import { appStore } from '@/app_store';
import { en } from './en';
import { pl } from './pl';
import { ua } from './ua';

type Translations = typeof en;
export type TranslationKey = keyof Translations;

const TRANSLATIONS: Record<string, Translations> = { en, pl, ua };

export function t(key: TranslationKey): string {
    const lang = appStore.settings.currentSettings?.language ?? 'en';
    return (TRANSLATIONS[lang] ?? en)[key];
}
